import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_CLIENT_INFO_SUCCESS,
  FETCH_CLIENT_VISITS_SUCCESS,
  FETCH_CLIENT_SALES_SUCCESS,
  FETCH_CLIENT_PAST_DUES_SUCCESS,
  FETCH_CLIENT_CONTRACTS_SUCCESS,
  FETCH_CONTRACTS_STATUSES_SUCCESS,
  FETCH_CONTRACTS_FREEZES_SUCCESS,
  FETCH_CLIENT_CONTACT_LOGS_SUCCESS,
  FETCH_CLIENT_CHARTS_SUCCESS,
  FETCH_DATA_ERROR,
  SEND_CONTACT_LOG_REQUEST_SUCCESS,
  SET_CLIENT_LOGS_LOADING,
  SET_API_ERROR, FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS, FETCH_CLIENT_PROSPECT_TYPES_SUCCESS
} from "../sagas/clientProfile/clientProfile";

export const initialState = {
  currentUser: {},
  clientInfo: {},
  clientVisits: {},
  clientSales: {},
  clientPastDues: {},
  clientContactLogs: {
    tableInfo: {
      data: []
    }
  },
  contractStatuses: {
    tableInfo: {
      data: []
    }
  },
  contractFreezes: {
    tableInfo: {
      data: []
    }
  },
  clientContracts: {
    tableInfo: {
      data: []
    }
  },
  clientCharts: {},
  haveError: false,
  error: "",
  isLoading: true,
  clientLogsLoading: true,
  apiError: false
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_CLIENT_LOGS_LOADING]: (state, action) => ({
      ...state,
      clientLogsLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_CLIENT_INFO_SUCCESS]: (state, action) => ({
      ...state,
      clientInfo: action.payload || state.clientInfo
    }),
    [FETCH_CLIENT_VISITS_SUCCESS]: (state, action) => ({
      ...state,
      clientVisits: action.payload || state.clientVisits
    }),
    [FETCH_CLIENT_SALES_SUCCESS]: (state, action) => ({
      ...state,
      clientSales: action.payload || state.clientSales
    }),
    [FETCH_CLIENT_PAST_DUES_SUCCESS]: (state, action) => ({
      ...state,
      clientPastDues: action.payload || state.clientPastDues
    }),
    [FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS]: (state, action) => ({
      ...state,
      clientMembershipTypes: action.payload || state.clientMembershipTypes
    }),
    [FETCH_CLIENT_PROSPECT_TYPES_SUCCESS]: (state, action) => ({
      ...state,
      clientProspectTypes: action.payload || state.clientProspectTypes
    }),
    [FETCH_CLIENT_CONTRACTS_SUCCESS]: (state, action) => ({
      ...state,
      clientContracts: action.payload || state.clientContracts
    }),
    [FETCH_CONTRACTS_STATUSES_SUCCESS]: (state, action) => {
      return { ...state, contractStatuses: action.payload || state.contractStatuses };
    },
      [FETCH_CONTRACTS_FREEZES_SUCCESS]: (state, action) => {
          return { ...state, contractFreezes: action.payload || state.contractFreezes };
      },
    [FETCH_CLIENT_CONTACT_LOGS_SUCCESS]: (state, action) => ({
      ...state,
      clientContactLogs: action.payload || state.clientContactLogs
    }),
    [SEND_CONTACT_LOG_REQUEST_SUCCESS]: (state, action) => ({
      ...state,
      clientContactLogs: action.payload || state.clientContactLogs
    }),
    [FETCH_CLIENT_CHARTS_SUCCESS]: (state, action) => ({
      ...state,
      clientCharts: action.payload || state.clientCharts
    }),
    [FETCH_DATA_ERROR]: (state, action) => ({
      ...state,
      haveError: true,
      error: action.payload.response.data.error
    }),
    [SET_API_ERROR]: (state, action) => ({
      ...state,
      apiError: action.payload
    })
  },
  initialState
);
